import { render, staticRenderFns } from "./ReviewRules.vue?vue&type=template&id=dc0ac6aa&scoped=true&"
import script from "./ReviewRules.vue?vue&type=script&lang=js&"
export * from "./ReviewRules.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRules.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReviewRules.vue?vue&type=style&index=1&id=dc0ac6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0ac6aa",
  null
  
)

export default component.exports